import React from 'react';
import { useMediaQuery } from 'usehooks-ts';
import styles from './ServiceAndMaintenanceStepItem.module.scss';
import Chevron from '../../../../Icons/Chevron';

const StepItem = ({ step, index, onClickStep }) => {
  const isTablet = useMediaQuery('(max-width: 834px)');
  const isMobile = useMediaQuery('(max-width: 480px)');

  const getImageUrl = (imageField) => {
    if (!imageField?.fields) return '';

    const getImageUrlFromField = (field) => {
      if (!field?.value?.src) return '';
      return field.value.src;
    };

    if (isMobile) {
      return (
        getImageUrlFromField(imageField.fields.mobileImage) ||
        getImageUrlFromField(imageField.fields.tabletImage) ||
        getImageUrlFromField(imageField.fields.desktopImage) ||
        ''
      );
    }

    if (isTablet) {
      return (
        getImageUrlFromField(imageField.fields.tabletImage) ||
        getImageUrlFromField(imageField.fields.desktopImage) ||
        ''
      );
    }

    return getImageUrlFromField(imageField.fields.desktopImage) || '';
  };

  const imageUrl = getImageUrl(step.image);
  const title = step?.title || '';
  const textContent = step?.text || '';

  return (
    <div className={styles.wrapper} data-aos="fade-up">
      <div className={styles.image}>
        <img src={imageUrl} alt="Step" />
      </div>
      <div className={styles.card}>
        <div className={styles.card_inner}>
          <div>
            <h3 className={styles.card_title}>{title}</h3>
            <div className={styles.card_text} dangerouslySetInnerHTML={{ __html: textContent }} />
          </div>
          <div className={styles.buttons}>
            {index > 0 && (
              <button className={styles.buttonBack} onClick={() => onClickStep(step.id - 1)}>
                <Chevron color="rgba(18, 18, 18, 1)" isRotated />
              </button>
            )}
            <div className={styles.buttonWrapper}>
              {step?.buttonPath ? (
                <a href={step?.buttonPath} className={styles.buttonWrapper_button}>
                  {step.buttonText}
                  <Chevron />
                </a>
              ) : (
                <button
                  className={styles.buttonWrapper_button}
                  onClick={() => onClickStep(step.id + 1)}
                >
                  {step.buttonText}
                  <Chevron />
                </button>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default StepItem;
